import { PricingSlider } from './PricingSlider'

interface PricingCalculatorProps {
  volCorreo: number
  volWhatsapp: number
  volCorreoWhatsapp: number
  setVolCorreo: (v: number) => void
  setVolWhatsapp: (v: number) => void
  setVolCorreoWhatsapp: (v: number) => void
}

export function PricingCalculator({
  volCorreo,
  volWhatsapp,
  volCorreoWhatsapp,
  setVolCorreo,
  setVolWhatsapp,
  setVolCorreoWhatsapp,
}: PricingCalculatorProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-300 p-4 lg:p-6">
      <div className="space-y-6">
        <PricingSlider
          label="Correo"
          servicio="correo"
          valor={volCorreo}
          onChange={setVolCorreo}
        />

        <PricingSlider
          label="WhatsApp"
          servicio="whatsapp"
          valor={volWhatsapp}
          onChange={setVolWhatsapp}
        />

        <PricingSlider
          label="Correo + WhatsApp"
          servicio="correo_whatsapp"
          valor={volCorreoWhatsapp}
          onChange={setVolCorreoWhatsapp}
        />
      </div>
    </div>
  )
}
